import { COMBAT_NEAR_RADIUS } from './sceneRenderConfig.js';

export interface CombatAxialCoord {
  readonly q: number;
  readonly r: number;
}

export interface CombatFight {
  readonly attackerOwnerId: number | null;
  readonly defenderOwnerId: number | null;
  readonly position: CombatAxialCoord | null;
}

export function shouldAnimateCombat(
  fight: CombatFight,
  localPlayerIndex: number,
  localCapital: CombatAxialCoord | null,
): boolean {
  if (fight.attackerOwnerId === localPlayerIndex || fight.defenderOwnerId === localPlayerIndex) {
    return true;
  }

  if (!localCapital || !fight.position) return false;
  if (
    !Number.isFinite(localCapital.q) ||
    !Number.isFinite(localCapital.r) ||
    !Number.isFinite(fight.position.q) ||
    !Number.isFinite(fight.position.r)
  ) {
    return false;
  }

  const distance = axialDistance(fight.position, localCapital);
  return distance <= COMBAT_NEAR_RADIUS;
}

function axialDistance(a: CombatAxialCoord, b: CombatAxialCoord): number {
  return (Math.abs(a.q - b.q) + Math.abs(a.r - b.r) + Math.abs(a.q + a.r - b.q - b.r)) / 2;
}

export { COMBAT_NEAR_RADIUS };

export default shouldAnimateCombat;
